import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './shoppingListsServices';

/* jshint -W106 */  // Disable warnings for non-camelCase identifiers (application_id)

const shoppingListsControllers = angular.module('applicationModule.shoppingListsControllers', [
    'applicationModule.shoppingListsServices',
    'ui.bootstrap',
    'ui.select'
]);

shoppingListsControllers.controller('ShoppingListController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'ShoppingLists', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $state, NgTableParams, ShoppingLists, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('shopping_lists');
    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return ShoppingLists.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.shopping_lists.total);
                    params.count(response.shopping_lists.per_page);
                    params.page(response.shopping_lists.current_page);

                    if (angular.isDefinedNotNull($stateParams.searchShoppingLists)) {
                        $scope.search = $stateParams.searchShoppingLists;
                        $scope.searchShoppingLists($scope.search);
                    }

                    return response.shopping_lists.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.searchShoppingLists = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.hash)) {
            $scope.tableParams._params.hash = undefined;
        }
        $stateParams.searchCategories = null;
        $scope.searchItem = null;
    };
    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

export default shoppingListsControllers;
